"use client";

import { useSyncExternalStore } from "react";

const emptySubscribe = () => () => {};

/**
 * False during SSR and the hydration render, true afterwards — the
 * useSyncExternalStore form, which satisfies react-hooks/set-state-in-effect
 * and cannot mismatch (the server snapshot is always false).
 *
 * Use it to defer browser-only derivations (visitor-local time formatting,
 * storage reads) to render time instead of effect+setState.
 */
export function useHydrated(): boolean {
  return useSyncExternalStore(emptySubscribe, () => true, () => false);
}
